<template>
  <Shell :current-route="currentRoute" homeRoute="personal">
    <template #appName>Hồ Sơ</template>
    <Personal @route-changed="handleRouteChange" />
  </Shell>
</template>

<script>
import {ref, computed, onMounted, onUnmounted, h} from 'vue';
import Shell from "@/layouts/shell.vue";
import { defineAsyncComponent } from 'vue'

const Personal = defineAsyncComponent(() =>
    import("personal/main").then(({ mount }) => ({
      setup(props, {emit}) {
        const el = ref(null);
        let router;

        onMounted(() => {
          const instance = mount(el.value);
          router = instance.router;

          router.afterEach((to) => {
            emit('route-changed', {
              name: to.name,
              fullPath: to.fullPath,
              path: to.path,
              meta: to.meta,
            });
          });
        });

        onUnmounted(() => {
          if (router) {
            window.location.reload();
          }
        });

        return () => h("div", {ref: el});
      }
    }))
);

export default {
  components: {
    Personal,
    Shell,
    // MyWebComponent: () => import('./path-to-my-web-component.vue')
  },
  setup() {
    const currentRoute = ref(null);
    const excludedRouteNames = [
      'login',
      'register',
      'forgot-password',
      'tours.rate.sale.view',
      'tours.rate.executive.view',
      'tours.rate.customer'
    ]; // Add the route names you want to exclude

    const handleRouteChange = (route) => {
      currentRoute.value = route;
    };

    const shouldShowWebComponent = computed(() => {
      if (!currentRoute.value) return false;
      return !excludedRouteNames.includes(currentRoute.value.name);
    });

    return {
      currentRoute,
      handleRouteChange,
      shouldShowWebComponent
    };
  }
};
</script>

<style scoped>
#apps {
  /* Your styles here */
}
</style>